import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Switch from 'react-switch'
import { COLORS, VIEW_CHOICES, UNIT_OF_MEASUREMENT_OPTIONS, IMPERIAL, METRIC } from 'helpers/globals'
import { updateUiAction, updateUnitAction } from 'actions/uiActions'
import { checkOfflineLimitsAction } from 'actions/applicationActions'

const mapStateToProps = ({ ui: { cameraViewsChoice, isImperial, showCameraBlindspot, showAnalyticZones, showWallBlindspots, showSimpleCameraIcon }, permalink }) => {
  return {
    cameraViewsChoice,
    showCameraBlindspot,
    showAnalyticZones,
    showWallBlindspots,
    showSimpleCameraIcon,
    isImperial,
    permalink
  }
}

const Label = ({ id, labelText, checked, onChange, disabled, indent = true, showEdit = false, onEditClick, classes }) => (
  <div className={indent ? classes.indentedRow : classes.row}>
    <div className={classes.label + (disabled ? ' disabled' : '')}>
      <span>
        { labelText }
        { showEdit &&
          <a onClick={_ => !disabled && checked && onEditClick()} className={disabled || !checked ? 'disabled' : ''}>
            <FontAwesomeIcon icon='edit' /> Edit
          </a>
        }
      </span>
      <Switch
        checked={checked}
        onChange={onChange}
        onColor='#5CA5E4'
        onHandleColor={COLORS.primary}
        handleDiameter={25}
        uncheckedIcon={false}
        checkedIcon={false}
        boxShadow='0px 1px 5px rgba(0, 0, 0, 0.6)'
        activeBoxShadow='0px 0px 1px 10px rgba(0, 0, 0, 0.2)'
        height={17}
        width={40}
        className={classes.switch + ' react-switch'}
        id={id}
        disabled={disabled}
      />
    </div>
  </div>
)

class ViewOptionsPanel extends React.Component {
  onChangeFunction = key =>
    changed => this.props.updateUiAction({ [`${key}`]: changed })

  viewChoiceButton = (choice, key, currentValue) => {
    const { updateUiAction, classes } = this.props

    return (
      <div
        onClick={_ => choice.value !== currentValue && updateUiAction({ [key]: choice.value })}
        className={classes.viewChoice + (currentValue === choice.value ? ' selected' : '')}
        key={choice.text}
      >
        {choice.text}
      </div>
    )
  }

  viewUnitChoiceButton = choice => {
    const { updateUnitAction, isImperial, classes } = this.props
    const unitValue = isImperial ? IMPERIAL : METRIC

    return (
      <div
        onClick={_ => choice.value !== unitValue && updateUnitAction(choice.value === IMPERIAL)}
        className={classes.viewChoice + (unitValue === choice.value ? ' selected' : '')}
        key={choice.text}
      >
        {choice.text}
      </div>
    )
  }

  render() {
    const { props: { cameraViewsChoice, showCameraBlindspot, showAnalyticZones, showWallBlindspots, showSimpleCameraIcon, isImperial,
      checkOfflineLimitsAction, isMobile, permalink, classes }, viewChoiceButton, viewUnitChoiceButton, onChangeFunction } = this

    const disabled = cameraViewsChoice === 'None'
    const onEditClick = _ => checkOfflineLimitsAction('modal', ['AnalyticZonesSelector'])

    return (
      <div className={classes.container}>
        <div className={isMobile ? classes.mobileFirstRow : classes.firstRow}>
          <div style={{ flex: '1 1 auto' }}>Show views from:</div>
          <div className={classes.inputWrapper}>
            { VIEW_CHOICES.map(choice => viewChoiceButton(choice, 'cameraViewsChoice', cameraViewsChoice)) }
          </div>
        </div>
        <Label {...{ id: 'showBlindspotSwitch', labelText: 'Show camera blind spots', checked: showCameraBlindspot, onChange: onChangeFunction('showCameraBlindspot'), disabled, classes }} />
        <Label {...{ id: 'showAnalyticZonesSwitch', labelText: `Show ${isImperial ? 'PPF' : 'PPM'} zones`, checked: showAnalyticZones, onChange: onChangeFunction('showAnalyticZones'), disabled, showEdit: !isMobile && !permalink, onEditClick, classes }} />
        <Label {...{ id: 'showWallBlindSpotsSwitch', labelText: 'Show wall blind spots', checked: showWallBlindspots, onChange: onChangeFunction('showWallBlindspots'), disabled, classes }} />
        <Label {...{ id: 'showSimpleCameraIconSwitch', labelText: 'Use simple camera icons', checked: showSimpleCameraIcon, onChange: onChangeFunction('showSimpleCameraIcon'), disabled: false, indent: false, classes }} />
        <div className={classes.firstRow}>
          <div style={{ flex: '1 1 auto' }}>Unit of measurement:</div>
          <div className={classes.inputWrapper} style={{ marginRight: isMobile ? 0 : '5.5rem' }}>
            { UNIT_OF_MEASUREMENT_OPTIONS.map(choice => viewUnitChoiceButton(choice)) }
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateUiAction, updateUnitAction, checkOfflineLimitsAction })(injectSheet(style)(ViewOptionsPanel))



// WEBPACK FOOTER //
// ./src/components/ViewOptionsPanel/index.js